<script>
    import { spotTypes } from "./Constants";
    import { spotTypeBeforeAPICall } from "./Stores";

    let buttonStyle =
        "cursor-pointer inline-flex items-center py-2 px-3 text-base sm:text-lg hover:font-bold ";
</script>

<div class="flex justify-center mt-3 mb-2 relati">
    <div class="inline-flex outline outline-neutral-100 rounded-md">
        <div>
            <input
                type="radio"
                name="radio"
                id="ife"
                class="sr-only peer"
                cy_data="ife_switch"
                checked
                on:click={() => {
                    $spotTypeBeforeAPICall = spotTypes.IFE;
                }}
            />
            <label id="labelIFE" for="ife" class={buttonStyle}> IFE </label>
        </div>
        <div>
            <input
                type="radio"
                name="radio"
                id="iac"
                class="sr-only peer"
                cy_data="iac_switch"
                on:click={() => {
                    $spotTypeBeforeAPICall = spotTypes.IAC;
                }}
            />
            <label id="labelIAC" for="iac" class={buttonStyle}> IAC </label>
        </div>
    </div>
</div>

<style>
    input:checked + label {
        background-color: #f1f5f9;
        color: #164e63;
        font-weight: bold;
    }

    #labelIFE {
        border-top-left-radius: 0.375rem;
        border-bottom-left-radius: 0.375rem;
    }

    #labelIAC {
        border-top-right-radius: 0.375rem;
        border-bottom-right-radius: 0.375rem;
    }
</style>
